export const getters = {
  getWidgetsRemaining(state) {
    return state.unrenderedWidgets?.size;
  },
  widgetsAreReadyToPaginate(state) {
    return (
      Object.values(state.readyToPaginateWidgets).filter(Boolean).length >= state.paginationTarget
    );
  },
  isReadyToPaginate(state) {
    return state.isReadyToPaginate;
  },
  getWidgetsToPaginate(state) {
    return Object.keys(state.readyToPaginateWidgets);
  },
  getFromPaginationQueue(state, widgetId) {
    return state.paginationQueue[widgetId];
  },
  paginationIsReadyToDisplay(state) {
    return state.measuredElementsCounter >= state.paginationTarget;
  },
  getIsReadyToDisplay(state) {
    return state.isReadyToDisplay;
  },
  getMeasuredElementsInLayout(state, layoutId) {
    return state.measuredElements[layoutId];
  },
  getMeasuredElements(state) {
    return Object.values(state.measuredElements).reduce((acc, curr) => [...acc, ...curr], []);
  },
  getExecutiveSummaryQueue(state) {
    return state.executiveSummaryQueue;
  },
};
